<!-- begin:: Footer -->

<div *ngIf="isMobile" class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
	<div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
		<div class="row">
			<span *ngIf="!isDashboard()" [routerLink]="['/dashboard/dashboard']" class="initialbutton kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">Dashboard</span>
			<span *ngIf="isDashboard()" class="initialbutton kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">Dashboard</span>
			<span (click)="goToFavorites()" class="otherbutton kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">Favorites</span>
			<span (click)="logout()" class="otherbutton kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">Logout</span>


			<!-- <div class="row m-0 initialbutton" [ngStyle]="{'background-color': 'rgb(0, 91, 170)', 'color': 'rgb(255, 210, 0)'}">
					<mat-icon *ngIf="!isDashboard()" [routerLink]="['/dashboard/dashboard']">	<i class="fas fa-tachometer-alt" aria-hidden="true"></i></mat-icon>
					<mat-icon *ngIf="isDashboard()" >	<i class="fas fa-tachometer-alt" aria-hidden="true"></i></mat-icon>

				</div> -->
			<!-- <div class="row m-0 otherbutton" [ngStyle]="{'background-color': 'rgb(0, 91, 170)', 'color': 'rgb(255, 210, 0)'}">
				<mat-icon (click)="goToFavorites()">	<i class="fa fa-star" aria-hidden="true"></i></mat-icon>
			</div>
			<div class="row m-0" [ngStyle]="{'background-color': 'rgb(0, 91, 170)', 'color': 'rgb(255, 210, 0)'}">
				<mat-icon (click)="logout()">	<i class="fas fa-sign-out-alt" aria-hidden="true"></i></mat-icon>
			</div> -->
		</div>

	</div>
</div>
<!-- end:: Footer -->
